export const homeObjectOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "premuim service",
  headLine: "Guaranteed Enrollment in Over 100 Companies",
  description:
    "Get Access to our exclusive app that opens the gate to train with Experts in over 100 different companies in different fields",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/work.svg").default,
  alt: "car",
  dark: true,
  primary: true,
  darkText: false,
  link: "/signup",
};
export const homeObjectTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Career support",
  headLine: "Real time support through dedicated teams",
  description:
    "Get real time feedback and Career support through recommened paths studied by our teams to help you jump starting your career",
  buttonLabel: "Learn more",
  imgStart: true,
  img: require("../../images/cv.svg").default,
  alt: "car",
  dark: false,
  primary: false,
  darkText: true,
  link: "/",
};
export const homeObjectThree = {
  id: "goal",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Our Aim",
  headLine: "Still getting no replies on your applications?",
  description:
    "Practikum helps you through the journey of gaining career skills and experience without the hassle of hunting internships and waiting for companies responses ",
  buttonLabel: "Learn more",
  imgStart: true,
  img: require("../../images/story.svg").default,
  alt: "car",
  dark: false,
  primary: false,
  darkText: true,
  link: "/",
};

export const homeObjectFour = {
  id: "construction",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Working on it",
  headLine: "The product is still under construction",
  description:
    "Thank you for your interest in our product. We hope one day we can change the lifes of many student. Be sure to sign up to receive notification when our product is finished!",
  buttonLabel: "Sign up",
  imgStart: false,
  img: require("../../images/progress.svg").default,
  alt: "car",
  dark: true,
  primary: true,
  darkText: false,
  link: "/",
};

export const homeObjectFive = {
  id: "contactus",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Contact Us",
  headLine: "",
  description: "",
  buttonLabel: "Learn more",
  imgStart: true,
  img: require("../../images/contactus.svg").default,
  alt: "car",
  dark: false,
  primary: false,
  darkText: true,
  link: "/",
};
